import { render, staticRenderFns } from "./ShopProductGroupBuyGroup.vue?vue&type=template&id=46b5c617&scoped=true&"
import script from "./ShopProductGroupBuyGroup.vue?vue&type=script&lang=js&"
export * from "./ShopProductGroupBuyGroup.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductGroupBuyGroup.vue?vue&type=style&index=0&id=46b5c617&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5c617",
  null
  
)

export default component.exports